import Model from './Model'

export default class RoleModel extends Model {
  public id: number|undefined

  resource () : string {
    return 'roles'
  }
}
